import React from 'react';
import { useParams } from 'react-router-dom';

const DesignPage = () => {
    const { category } = useParams();

    return (
        <div>
            <h1>Design Page for {category}</h1>
            {/* Render your designs here based on the category */}
        </div>
    );
}

export default DesignPage;
